var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReImagine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4189_5141)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4189_5141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4189_5141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0.52734V4.09099",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64498 5.50123L8.23768 8.02109",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4189_5141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4189_5141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.527344 17.5092H4.19393",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64498 29.5172L8.23768 26.9974",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.355 29.5172L27.7623 26.9974",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4189_5141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4189_5141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4727 17.5092H31.8061",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.355 5.50123L27.7623 8.02109",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4189_5141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4189_5141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8446 10.008C27.3155 11.7521 28.2001 13.9945 28.2001 16.4408C28.2001 19.168 27.1005 21.6418 25.3151 23.4543C24.1967 24.5896 23.3299 25.5988 23.3298 27.1705V28.407",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34906 19.7066C7.99314 18.6826 7.79992 17.5839 7.79992 16.4408C7.79992 10.8827 12.3667 6.37703 18 6.37703C20.2454 6.37703 22.3216 7.09288 24.0064 8.30598",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8877 28.4249V27.221C12.8876 25.6492 11.8034 24.5897 10.685 23.4543C10.2207 22.983 9.80283 22.4671 9.43861 21.9136",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0798 32.6536H15.1377C13.8951 32.6536 12.8877 31.6462 12.8877 30.4036V27.0153H23.3298V30.4036C23.3298 31.6462 22.3225 32.6536 21.0798 32.6536Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.952 32.583V33.3583C21.952 34.5261 20.978 35.4727 19.7767 35.4727H16.4409C15.2395 35.4727 14.2655 34.5261 14.2655 33.3583V32.583",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4807 29.8344H23.3298",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8877 29.8344H18.9427",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.246 19.4742H19.5591V17.8788C19.5591 17.0083 20.2648 16.3026 21.1352 16.3026H21.246C22.1166 16.3026 22.8222 17.0083 22.8222 17.8788V17.898C22.8222 18.7685 22.1166 19.4742 21.246 19.4742Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9715 19.4742H16.6585V17.8788C16.6585 17.0083 15.9528 16.3026 15.0823 16.3026H14.9715C14.101 16.3026 13.3953 17.0083 13.3953 17.8788V17.898C13.3953 18.7685 14.101 19.4742 14.9715 19.4742Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 27.0153V19.4741H18.5999H16.6585V27.0153",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0.52734V4.09099",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64498 5.50123L8.23768 8.02109",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.527344 17.5092H4.19393",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64498 29.5172L8.23768 26.9974",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.355 29.5172L27.7623 26.9974",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4727 17.5092H31.8061",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.355 5.50123L27.7623 8.02109",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8446 10.008C27.3155 11.7521 28.2001 13.9945 28.2001 16.4408C28.2001 19.168 27.1005 21.6418 25.3151 23.4543C24.1967 24.5896 23.3299 25.5988 23.3298 27.1705V28.407",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34906 19.7066C7.99314 18.6826 7.79992 17.5839 7.79992 16.4408C7.79992 10.8827 12.3667 6.37703 18 6.37703C20.2454 6.37703 22.3216 7.09288 24.0064 8.30598",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8877 28.4249V27.221C12.8876 25.6492 11.8034 24.5897 10.685 23.4543C10.2207 22.983 9.80283 22.4671 9.43861 21.9136",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0798 32.6536H15.1377C13.8951 32.6536 12.8877 31.6462 12.8877 30.4036V27.0153H23.3298V30.4036C23.3298 31.6462 22.3225 32.6536 21.0798 32.6536Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.952 32.583V33.3583C21.952 34.5261 20.978 35.4727 19.7767 35.4727H16.4409C15.2395 35.4727 14.2655 34.5261 14.2655 33.3583V32.583",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4807 29.8344H23.3298",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8877 29.8344H18.9427",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.246 19.4742H19.5591V17.8788C19.5591 17.0083 20.2648 16.3026 21.1352 16.3026H21.246C22.1166 16.3026 22.8222 17.0083 22.8222 17.8788V17.898C22.8222 18.7685 22.1166 19.4742 21.246 19.4742Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9715 19.4742H16.6585V17.8788C16.6585 17.0083 15.9528 16.3026 15.0823 16.3026H14.9715C14.101 16.3026 13.3953 17.0083 13.3953 17.8788V17.898C13.3953 18.7685 14.101 19.4742 14.9715 19.4742Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 27.0153V19.4741H18.5999H16.6585V27.0153",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4189_5141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReImagine);
export default __webpack_public_path__ + "static/media/REImagine.631c698e73a33694c2c29c233bef8eac.svg";
export { ForwardRef as ReactComponent };